import { render, staticRenderFns } from "./SaveControl.vue?vue&type=template&id=5ff58aca&scoped=true"
import script from "./SaveControl.vue?vue&type=script&lang=js"
export * from "./SaveControl.vue?vue&type=script&lang=js"
import style0 from "./SaveControl.vue?vue&type=style&index=0&id=5ff58aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff58aca",
  null
  
)

export default component.exports